export default {
	title: "Archive this goal?",
	description: "When you archive a goal no additional changes may be made to it, and it will not appear in your general goals list. Unarchiving the goal will make it active again.",
	confirmButton: "Archive goal",
	dismissButton: "Do not archive",
};
